import service from '@/store/services/fms/spj-service';

const state = {
  list: {},
  spj: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, spj) => {
    state.spj = spj;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },


  get({commit, dispatch}, params) {
    return service.get(params)
      .then((spj) => { commit('SET_RESOURCE', spj); });
  },


  add({commit, dispatch}, params) {
    return service.add(params)
      .then((spj) => { commit('SET_RESOURCE', spj); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((spj) => { commit('SET_RESOURCE', spj); });
  },

  update_status({commit, dispatch}, params) {
    return service.update_status(params)
      .then((spj) => { commit('SET_RESOURCE', spj); });
  },
  
  update_bulk({commit, dispatch}, params) {
    return service.update_bulk(params)
      .then((spj) => { commit('SET_RESOURCE', spj); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

  last_no({commit, dispatch}, params) {
    return service.last_no(params)
      .then((spj) => { commit('SET_RESOURCE', spj); });
  }
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  spj: state => state.spj,
  page: state => state.meta.page,

};
 
const spj = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default spj;
